import TextEditor, { getEditorProps, useEditorRef, usePlugins } from './text_editor';
export default TextEditor;
export { getEditorProps, useEditorRef, usePlugins };
